import React, { FC, HTMLAttributes } from 'react';
import clsx from 'clsx';

import { ReviewStar32Icon } from '@common/icons';
import { Gray_Light_600, Typography } from '@common/styles';

import { useProductCardContext } from '../../../context/ProductCardContext';
import { Hr, Root } from './Review.styled';

export interface ReviewProps extends HTMLAttributes<HTMLDivElement> {
  /**
   * 리뷰 사이즈
   * sm: 그리드 형태 상품 카드
   * lg: 리스트 형태 상품 카드
   */
  size: 'sm' | 'lg';
}

/**
 * 리뷰 컴포넌트
 */
export const Review: FC<React.PropsWithChildren<ReviewProps>> = ({ size, className, ...rest }) => {
  const { review_score, review_count } = useProductCardContext();

  if (!review_count || !review_score || review_score < 3) {
    return null;
  }

  if (size === 'sm') {
    return (
      <Root {...rest} className={clsx(className, Typography.CAPTION_10_MEDIUM)}>
        <ReviewStar32Icon color={Gray_Light_600} width={12} height={12} />
        <span className='score'>{review_score}</span>
        <span className='review-count'>({review_count})</span>
      </Root>
    );
  }

  return (
    <Root {...rest} className={clsx(className, Typography.CAPTION_10_MEDIUM)}>
      <ReviewStar32Icon color={Gray_Light_600} width={12} height={12} />
      <span className='score'>{review_score}</span>
      <Hr />
      <span className='review-count'>리뷰{review_count}</span>
    </Root>
  );
};
